<template>
    <div class="d-flex d-inline">
        <div class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i @click="removeTemplate" class="fa fa-trash"></i>
        </div>
        <router-link :to="{ name: 'online_contract_edit_template', params: { hashid: row.id }}"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fa fa-eye"></i>
        </router-link>
        <div>
            <a @click="downloadFile(row)" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                <i v-if="!is_downloading" class="fa fa-download"></i>
                <i v-else class="fa fa-spinner"></i>
            </a>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import {i18n} from '@/plugins/i18n'
import toastr from 'toastr'
import {mapGetters} from "vuex";
import axios from "axios";
import {ApiUrl, onlineContractService} from "@/common/api.service";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            is_downloading: false
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    methods: {
        removeTemplate: function () {
            var result = confirm(i18n.t('online_contract.message.confirm_remove_template'));
            if (!result) return;

            onlineContractService.removeTemplate(this.row.id).then(response => {
                this.datatable.reload()
                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            });
        },
        downloadFile(row) {
            if (this.is_downloading)
                return;
            this.is_downloading = true;
            axios({
                url: ApiUrl.path(`online-contract/template/download/${row.id}`),
                method: 'GET',
                params: {},
                responseType: 'blob',
            }).then(
                response => {
                    let fileName = row.title + '.pdf'; // Default filename

                    // Create a URL for the blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); // Use the extracted filename
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link); // Clean up
                },
                error => {
                    this.toastr.error(i18n.t('reports.tax.failedMessage'))
                }).finally(()=>{
                    this.is_downloading = false
            });
        },
        downloadSignedFile(row) {
            axios({
                url: ApiUrl.path(`online-contract/contract/download-signed/${row.id}`),
                method: 'GET',
                params: {},
                responseType: 'blob',
            }).then(
                response => {
                    let fileName = row.id + '_' + row.user_full_name + '_' + row.start_at + '_' + row.end_at + '-signed' + '.pdf'; // Default filename

                    // Create a URL for the blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); // Use the extracted filename
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link); // Clean up
                },
                error => {
                    this.toastr.error(i18n.t('reports.tax.failedMessage'))
                });
        },
    },
})
</script>

<style>

</style>